export function isOdd(n) {
  return Math.abs(n % 2) == 1
}

export function isEven(n) {
  return n % 2 == 0
}
